/*@ngInject*/
const OrganizationActionUtil = function ($rootScope, $state, $uibModal, loadingBarHandler, modalUtil, organizationActionMediator, manageOrganizationMediator, uiPerformanceLoggerConstant, coreConstant, localization) {

    localization.getTranslations().then((translations) => {

        this.cancel = function (organizationId) {
            modalUtil.showConfirmationModal(
                /*submissionId*/null,
                /*quoteId*/null,
                /*notificationName*/null,
                'organization.cancelModal',
                uiPerformanceLoggerConstant.DELETE_ORGANIZATION,
                /*hideLoadingBar*/false,
                function () {
                    return organizationActionMediator.deleteOrganization(organizationId).then(function () {
                        $state.go('configuration.organizationBrowser', {organizationType: $state.params.organizationType});
                    });
                });
        };

            this.deactivateOrganization = function (organizationId) {
                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.DEACTIVATE_ORGANIZATION);
                modalUtil.showConfirmationModal(
                    null,
                    null,
                    null,
                    'organization.deactivateModal',
                    uiPerformanceLoggerConstant.DEACTIVATE_ORGANIZATION,
                    /*hideLoadingBar*/true,
                    function () {
                        let promise;
                        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'organization.deactivateOrganizationChangesLoadingBar'));
                        promise = organizationActionMediator.deactivateOrganization(organizationId).then(onSuccess, onError);
                        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                        return promise;
                    });

                function onSuccess() {
                    loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'organization.deactivateOrganizationChangesSuccessLoadingBar'));
                    $state.reload();
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.DEACTIVATE_ORGANIZATION, coreConstant.uiPeformanceLogger.SUCCESS);
                }

                function onError() {
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.DEACTIVATE_ORGANIZATION, coreConstant.uiPeformanceLogger.FAIL);
                }
            };

            this.activateOrganization = function (organizationId) {
                let promise;
                loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'organization.activateOrganizationChangesLoadingBar'));
                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ACTIVATE_ORGANIZATION);
                promise = organizationActionMediator.activateOrganization(organizationId).then(onSuccess, onError);
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;

                function onSuccess() {
                    loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'organization.activateOrganizationChangesSuccessLoadingBar'));
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ACTIVATE_ORGANIZATION, coreConstant.uiPeformanceLogger.SUCCESS);
                }

                function onError() {
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ACTIVATE_ORGANIZATION, coreConstant.uiPeformanceLogger.FAIL);
                }
            };

        this.getFormSetId = function (organizationId) {
            return organizationActionMediator.getFormSetId(organizationId);
        };

        this.editEmailSignature = function (organization) {
            const modalInstance = $uibModal.open({
                templateUrl: '/configuration/organizationBrowser/manageOrganization/emailSignatureModal/emailSignatureModal.tpl.html',
                controller: 'emailSignatureModalController',
                windowClass: 'emailSignatureModal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    options: {
                        emailSignature: organization.defaultEmailSignature
                    }
                }
            });

            modalInstance.result.then(function (result) {
                localization.getTranslationByKey('emailSignatureModal').then(function (translations) {
                    let promise;
                    function onSuccess() {
                        $rootScope.$broadcast(
                            coreConstant.event.END_UI_PERFORMANCE_LOG,
                            uiPerformanceLoggerConstant.UPDATE_EMAIL_SIGNATURE,
                            coreConstant.uiPeformanceLogger.SUCCESS);

                        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'updatingEmailSignatureSuccessLoadingBar'));
                    }

                    function onError() {
                        $rootScope.$broadcast(
                            coreConstant.event.END_UI_PERFORMANCE_LOG,
                            uiPerformanceLoggerConstant.UPDATE_EMAIL_SIGNATURE,
                            coreConstant.uiPeformanceLogger.FAIL);
                    }

                    loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'updatingEmailSignatureLoadingBar'));

                    $rootScope.$broadcast(
                        coreConstant.event.START_UI_PERFORMANCE_LOG,
                        uiPerformanceLoggerConstant.UPDATE_EMAIL_SIGNATURE,
                        organization.id);

                    promise = organizationActionMediator.updateEmailSignatureById(organization.id, result.emailSignature).then(onSuccess, onError);
                    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                    return promise;
                });
            });
        };

    });
};

angular.module('ums.configuration')
    .service('organizationActionUtil', OrganizationActionUtil);
